<template>
  <div class="loader" :style="{ width: size + 'px', height: size + 'px' }">
  </div>
</template>

<script>
export default {
  name: 'SpinnerLoader',
  props: ['size']
}
</script>

<style scoped lang="scss">
.loader {
  border: 0.5rem solid $gray-100;
  border-top: 0.5rem solid $primary;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
